import { Button } from "PFComponents/button";
import Tooltip from "PFComponents/tooltip/tooltip";
import { Feature } from "PFTypes/features";
import React from "react";
import { useTranslation } from "react-i18next";

import { featureDependenciesSatisfied, getUnsatisfiedDependencies } from "../utils/features_list_page.utils";

type ActionColumnProps = {
  feature: Feature;
  features: Feature[];
  onClick: (feature: Feature) => void;
};

export const ActionCell = ({ feature, features, onClick }: ActionColumnProps): JSX.Element => {
  const { t } = useTranslation("admin");

  const unsatisfiedDependencies = getUnsatisfiedDependencies(feature, features).join(", ");
  const areDependenciesSatisfied = featureDependenciesSatisfied(feature, features);

  const text = feature.active ? t("status.active") : t("status.inactive");
  const kind = feature.active ? "primary" : "danger";

  return (
    <Tooltip
      content={`Dependencies not satisfied: ${unsatisfiedDependencies}`}
      disabled={areDependenciesSatisfied}
    >
      <span>
        <Button
          kind={kind}
          small
          style={{ width: "120px" }}
          onClick={() => onClick(feature)}
          disabled={!areDependenciesSatisfied}
        >
          {text}
        </Button>
      </span>
    </Tooltip>
  );
};
